import React from 'react'
import LifeInsuranceForm from './Components/LifeInsuranceForm'

const LifeInsurance = () => {
    return (
        <div>
            {/* x---------------------------------x Life Insurance Form Section x---------------------------------x */}
            <div className="row g-3 coustom-card">
                <div className="col-sm-12">
                    <div className="card h-100">
                        <div className="card-header justify-content-between">
                            <h2 className="fs-5 fw-semibold">Life Insurance Application Form</h2>
                        </div>
                        <div className="rounded-4 mb-3 mb-sm-0 bg-white">
                            <div className="card-body rounded">
                                {/* x---------------------------------x Life Insurance Form x---------------------------------x */}
                                <LifeInsuranceForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LifeInsurance